import { getAuthHeader } from './authApi';

const isProduction = process.env.NODE_ENV === 'production';
const API_URL = isProduction ? '/api/v1' : (process.env.REACT_APP_API_URL || 'http://localhost:8080/api/v1');

export interface Tech {
    id: number;
    name: string;
    displayOrder: number;
}

const fallbackTech: Tech[] = [
    { id: 1, name: 'React', displayOrder: 1 },
    { id: 2, name: 'TypeScript', displayOrder: 2 },
    { id: 3, name: 'Spring Boot', displayOrder: 3 },
    { id: 4, name: 'Java', displayOrder: 4 },
    { id: 5, name: 'MySQL', displayOrder: 5 },
    { id: 6, name: 'Docker', displayOrder: 6 },
    { id: 7, name: 'REST APIs', displayOrder: 7 },
    { id: 8, name: 'Microservices', displayOrder: 8 },
    { id: 9, name: 'Cloud Computing', displayOrder: 9 }
];

export const techApi = {
    getAllTech: async (): Promise<Tech[]> => {
        try {
            const response = await fetch(`${API_URL}/tech`);
            if (!response.ok) {
                return fallbackTech;
            }
            const data = await response.json();
            return data.length > 0 ? data : fallbackTech;
        } catch (error) {
            console.error('Error fetching tech stack:', error);
            return fallbackTech;
        }
    },

    addTech: async (tech: Omit<Tech, 'id'>): Promise<Tech> => {
        const response = await fetch(`${API_URL}/tech`, {
            method: 'POST',
            headers: {
                ...getAuthHeader(),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(tech),
        });
        if (!response.ok) throw new Error('Failed to add tech');
        return response.json();
    },

    updateTech: async (id: number, tech: Partial<Tech>): Promise<Tech> => {
        const response = await fetch(`${API_URL}/tech/${id}`, {
            method: 'PUT',
            headers: {
                ...getAuthHeader(),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(tech),
        });
        if (!response.ok) throw new Error('Failed to update tech');
        return response.json();
    },

    deleteTech: async (id: number): Promise<void> => {
        const response = await fetch(`${API_URL}/tech/${id}`, {
            method: 'DELETE',
            headers: getAuthHeader(),
        });
        if (!response.ok) throw new Error('Failed to delete tech');
    }
};

// Keep for legacy compatibility if needed
export const fetchTechStack = techApi.getAllTech;
